const KEY = "siyaara_recently_viewed";

export function pushRecent(product) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY)) || [];
    const next = [
      { id: product.id, slug: product.slug, title: product.title,
        image: (product.images || [])[0] || "",
        price_min: product.price_min ?? 0, metal: product.metal, purity: product.purity },
      ...list.filter((p) => p.id !== product.id),
    ].slice(0, 8);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}

export function getRecents(excludeId) {
  try {
    const list = JSON.parse(localStorage.getItem(KEY)) || [];
    return list.filter((p) => p.id !== excludeId).slice(0, 4);
  } catch {
    return [];
  }
}
